jQuery(function($) {
    $('.mobile-toggle').on( "click", function() {
        $(".pdmp-mobile-menu .elementor-menu-toggle__icon--open").click();
        $(".mobile-toggle-container").toggleClass( "is-active" );
    });
});